<header c-top-bar-nx default-state="defaultState" class="about-theme"></header>
<div class="about-theme" c-main>
    <div class="content solo">
        <h1>{{'about.header'|translate}}</h1>
        <section>
            <p data-translate="productVersion|{{productVersion}}"></p>
            <p data-translate="databaseVersion|{{databaseVersion}}"></p>
        </section>
    </div>
</div>
<footer c-status-bar></footer>